import * as React from 'react';
import {
	// addSubjectColors,
	addSubjectColorsNew,
	prettifyImgUrl,
} from '../../../ta-services/ta-utils';
import { TaAnswerData } from '../../../ta-shared';
import { TaResultDetailsCard } from './ta-result-details-card/comp';

type TaResultDetailsSectionProps = {
	filteredAnswerssData: TaAnswerData[];
	bgColor?: string;
};

export const TaResultDetailsSection = ({
	filteredAnswerssData,
}: TaResultDetailsSectionProps) => {
	const score = filteredAnswerssData.reduce(
		(acc: number, value: any) => acc + value.score,
		0
	);

	const maxScore = 25;

	// const subjectColor = addSubjectColors(filteredAnswerssData[0]?.subject);
	const subjectColor = addSubjectColorsNew(score);

	const renderResultDetailsCards = () => {
		return filteredAnswerssData.map((answer: TaAnswerData) => {
			return (
				<TaResultDetailsCard
					topic={answer.topic}
					text={answer.text}
					icon={answer.icon}
					key={answer.answer}
				/>
			);
		});
	};

	return (
		<div
			className='ta-result-details-section_container'
			style={{ backgroundColor: subjectColor.bgColor || '#fff8f5'}}
		>
			<div className='ta-result-details-section_score'>
				{score}/{maxScore}
			</div>
			<div
				className='ta-result-details-section_bar'
				style={{backgroundColor: subjectColor.barBgColor || '#0d387b'}}
			>
				<div
					className='ta-result-details-section_bar-fill'
					style={{ backgroundColor: subjectColor?.barFillColor || '#40c6bb', width: score * (220 / maxScore)}}
				/>
			</div>
			<div className='ta-result-details-section_title'>
				<span>
					<img
						src={prettifyImgUrl(filteredAnswerssData[0]?.subjectIcon)}
						alt=''
					/>
				</span>
				<span>{filteredAnswerssData[0]?.subject}</span>
			</div>
			<div className='ta-result-details-section_cards'>
				{renderResultDetailsCards()}
			</div>
		</div>
	);
};
